<template>
    <div class="ganz-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">
                <div class="card card-widget widget-user">
                    <div class="widget-user-header text-white"
                        style="background: url('/assets/images/pexels-olia-danilevich-Excellence-Success-1920.png')  center;">

                        <h4 class="widget-user-desc text-left heading-border">"Never go to bed without a request</h4>
                        <h4 class="widget-user-desc text-left heading-border">to your Subconsious" - Thomas Edison</h4>
                        <h4 class="widget-user-desc text-right heading-border">Prioritize &amp; Focus = Results.</h4>
                    </div>
                    <div class="widget-user-image">
                        <img class="img-circle" src="/assets/images/pexels-wendel-moretti-Eye-Focus-128x128.png" alt="User Avatar">
                    </div>
                </div>
            </div>
        </div>

        <div class="card p-2">
            <div>
                <button @click="showVideoModal('morningevening_video')"
                    class="btn btn-sm btn-primary mb-2">Visualization Techniques Refresher</button>
            </div>
            <div>
                <button @click="showVideoModal('visualize_video')"
                    class="btn btn-sm btn-primary mb-2">Future-Self Vision</button>
            </div>
        </div>
        <div><button class="btn btn-sm btn-danger border-dark mb-2"><small>Gratitude: Give Thanks for 5 things & <i>feel</i> the joy</small></button></div>
 <div><button class="btn btn-sm btn-danger border-dark  mb-2"><small>What 3 Wins do I want to happen Today</small></button></div>
         <div>
            <div>
                <button @click="showPageModal('fs_visiondisplay', 'My Future-Self/Review my Vision')"
                        class="btn btn-sm btn-primary mb-2">My Future-Self/Review my Vision</button>
            </div>
             <div>
                <button @click="showPageModal('lettersdisplay', 'Letters to/from my Future-Self')"
                        class="btn btn-sm btn-primary mb-2">Letters to/from my Future-Self</button>
                <small class="hide-for-mobile"> (Connect with your Future-Self):</small>
            </div>
        </div>

         <div>

            <button @click="showPageModal('kssdisplay', 'Eliminate Self Sabotage')"
                        class="btn btn-sm btn-primary mb-2">Eliminate Self Sabotage</button>
                <small class="hide-for-mobile"> (Eliminate Self Sabotage):</small>
        </div>
        <div>
                <button @click="showPageModal('actionhabitsdisplay', 'Review My ActionHabits')"
                            class="btn btn-sm btn-primary mb-2">Review My ActionHabits</button>
                <small class="hide-for-mobile"> (Review My ActionHabits):</small>
        </div>
        <div>
            <a class="btn btn-sm btn-primary mb-2" href="/workout/myworkout">Review my next Workout</a>
        </div>
        <div v-if="uservideos">
            <a class="btn btn-sm btn-primary mb-2" href="/user/videos/display">My Supportive Videos</a>
        </div>
        <div v-else>
            <a class="btn btn-sm btn-primary mb-2" href="/user/videos">Setup Supportive Videos</a>
        </div>
<div><button class="btn btn-sm btn-warning border-dark mb-2" v-if="userinfo.id !=1"  @mouseover="showText = true" @mouseleave="showText = false" @touchstart="showText = true" @touchend="showText = false"><small>Request to your Subconscious</small></button></div>
 <div><button class="btn btn-sm btn-warning border-dark mb-2" v-if="userinfo.id==1" @mouseover="showText = true" @mouseleave="showText = false" @touchstart="showText = true" @touchend="showText = false"><small>For Mel: Request to your Subconscious</small></button></div>
<!-- <div id="appx"> -->
  <div>
  <p class="tooltipx card border-dark" style="z-index: 1000;" v-if="showText" v-html="req2subconscious"></p>
</div>
<!-- </div> -->

  </div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import EventBus from '../../event-bus';


export default {
    components: {
        // prizes,
        // celebration,

     },
    name: "MorningEveningFocus",
    data() {
        return {
            thisComponentName: '',
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            userinfo:'',
            userprefsData:[],
            newstarterreqsData:[],
            numdaysavailable:'',
            disclaimerText:'',
            prefs_daysavailable:'',
            disclaimer_tick:'',
            disclaimerAccepted:'',
            prefs_exercisetype:'',
            myFSDetails:'',
            videos:'',
            viewedQSVideo:false,
            rewatchVideoRequested: false,
            displayQSVideo:false,
            doneTimeSlice:false,
            video_duration:53,
            qsVideoSrc:'',
            isPausedStopped: true,
            videoIsPausedStopped: {},
            timeSlicesData:[],
            fsLettersData:[],
            celebrationReason:'',
            founderVideo:'',
            founderVideoSrc:'',
            founderVideoDuration:'',
            phyVideos:[],
            siteVideos:[],
            showText: false,
        }
    },

    props: {
        userdata:'',
        disclaimer:'',
        userprefs:'',
        disclaimer_acceptedx:'',
        disclaimeraccepted:'',
        myfsdetails:'',
        videolinks: '',
        newstarterreqs:'',
        timeslices: '',
        fsletters:'',
        uservideos:'',
        req2subconscious:'',
    },
    mounted() {
        this.thisComponentName = this.$options.name;
        this.userinfo = JSON.parse(this.userdata);
        this.disclaimerText = JSON.parse(this.disclaimer);
        this.userprefsData = JSON.parse(this.userprefs);
        this.myFSDetails = JSON.parse(this.myfsdetails);
        this.videos = JSON.parse(this.videolinks);
        this.siteVideos = [{'name': 'Visualization_HowTo', 'page_element_id':'qs_video', 'title':'', 'duration':0, 'src':''},
                {'name': this.thisComponentName + "_video", 'page_element_id':'morningevening_video', 'title':'', 'duration':0, 'src':''},
                {'name': "VisualizeVision_video", 'page_element_id':'visualize_video', 'title':'Visualize Your Future-Self', 'duration':0, 'src':''},
                {'name': 'Newbie_LegStrength_video', 'page_element_id':'phy_lowerbody_video', 'title':'', 'duration':0, 'src':''},
                {'name': 'Newbie_UpperBodyStrength_video', 'page_element_id':'phy_upperbody_video', 'title':'', 'duration':0, 'src':''},
                {'name': 'Newbie_Nutrition_video', 'page_element_id':'phy_nutr_video', 'title':'', 'duration':0, 'src':''}];

        this.setupThisPageVideos();

    },

    methods: {
        showPageModal(which, displayTitle) {
            //   const vidObj = this.getVideoObj(element_id);
            const payload = {title: displayTitle,
                            display: which,
                            };
            EventBus.$emit('displayPageModal', payload);

        },
        trackYTVideoPlayStatus() {
            var player = new YT.Player('ytvimeoplayer', {
                events: {
                    'onReady': onPlayerReadyYT,
                    'onStateChange': onPlayerStateChangeYT
                }
            });
        },
        onPlayerReadyYT(event) {
                // Video is ready to be played
                event.target.playVideo();
        },
        onPlayerStateChangeYT(event) {
            if (event.data == YT.PlayerState.PLAYING) {
                // Video is playing
                var duration = player.getDuration();
                setInterval(function() {
                    var currentTime = player.getCurrentTime();
                    var percentageWatched = (currentTime / duration) * 100;

                    // Check if video has been fully watched (assume 95% or more)
                    if (percentageWatched >= 90) {
                        // Video has been fully watched
                        console.log('Video fully watched!');
                        // Add your code to perform actions when video is fully watched
                        this.doubleConfirmOnVideoViewed('');
                    }
                }, 1000); // Check every second
            }
        },
        getVideoSource(url) {
            //returns 'VIMEO', 'YOUTUBE', 'OTHER'
            if(url.includes('youtube')||url.includes('youtu.be')) return 'YOUTUBE';
            if(url.includes('vimeo')) return 'VIMEO';
            return 'OTHER';
        },

        cancelRewatchVideo() {
            this. handleVideoClick('vid2');
            document.getElementById('rewatchVideoElement').hidden = true;
        },
        setupVideo() {
            const vidObj = this.getVideoObj('qs_video');
            this.video = vidObj;
            this.qsVideoSrc = vidObj.src;
            this.video_duration = vidObj.duration;
        },
        getVideoObj(element_id) {
           var vidObj = '';
            console.log("Looking for: " + element_id)
            this.siteVideos.forEach(vid => {
                if(vid.page_element_id == element_id) {
                    vidObj = vid;
                };
            });
            console.error(vidObj);
            return vidObj;

        },
        showVideoModal(element_id){
            console.log('Element_id' +element_id );
            const vidObj = this.getVideoObj(element_id);
            console.log(vidObj);
            const payload = {title:vidObj.title,
                            videourl: vidObj.src,
                            displayText: '<div>&nbsp;</div>'
                            };
            EventBus.$emit('displayVideoModal', payload);
        },
        setupThisPageVideos() {
            var vidObjArr = [];
            this.siteVideos.forEach(obj => {
                this.videos.forEach(video => {
                    if(video.name == obj.name) {
                        obj.src = video.url;
                        obj.duration = video.duration;
                        obj.title = video.title;
                        vidObjArr.push(obj);
                        if(obj.page_element_id.startsWith('phy')) {
                            this.phyVideos.push(obj);
                        }
                    }
                });
            });
            this.siteVideos = vidObjArr;
            // this.setupVideo();
        },

        checkShowStarterSection() {
            if ( this.viewedQSVideo  && this.timeSlicesData && this.disclaimerAccepted && this.myFSDetails
                && (this.userprefsData && this.userprefsData.agreedterms_cond != null)
                && (this.userprefsData && this.userprefsData.prefs_exercisetype != ''
                && this.userprefsData.numdaysavailable > 0)
                && (this.timeSlicesData.length > 0)
                && (this.fsLettersData.length > 0)) {
                // document.getElementById('newStarterWorkflow').hidden = true;
                // document.getElementById('celebrationSection').hidden = false;
                this.celebrationReason = "Yippee!! You've completed your New-Starter requirements!";
            } else {
                // document.getElementById('newStarterWorkflow').hidden = false;
                // document.getElementById('celebrationSection').hidden = true;
            }
        },
        handleVideoClick(vidRef) {
            // console.log("handleVideoClick: " + vidRef);
            //https://stackoverflow.com/questions/14161516/html5-video-completely-hide-controls
            //For Firefox we have to handle it in JavaScript
            //https://douglasgreen.com/demo/responsive-video-play-button/
        var vid =document.getElementById(vidRef);
        if (vid.paused) {
                vid.play();
                this.isPausedStopped = false;
            } else {
                vid.pause();
                this.isPausedStopped = true;
            }
        },
        handleTimeUpdate() {
            const currentTime = this.$refs.videoPlayer.currentTime;
            console.log(currentTime);
            const videoEnd = this.video_duration;
            if (currentTime >= videoEnd) {
                this.viewedQSVideo = true;
                this.doubleConfirmOnVideoViewed();
            }
        },
        recordQSVideoViewed(rewatchNotNeeded){
            console.log("New Starter Video rewatch not needed: " + rewatchNotNeeded);
              axios.post('/user/actions/saveupdate', {
                user_id:this.userinfo.id,
                qsvideowatched:this.viewedQSVideo,
                qsvideorewatch: !rewatchNotNeeded,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
               this.newstarterreqsData =JSON.parse(res.data.newstarterreqs);
                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err);
            })
            .finally(()=> {
               location.reload();
                // this.updateToast(this.message, 4000);
                // this.doubleConfirmOnVideoViewed(this.message) ;
                this.message = '';
            });

        },
        savePrefsButtonDisable() {
            if(this.userprefsData == null) return !(this.disclaimer_tick && this.prefs_daysavailable>0);
            if(this.userprefsData != null) return !(this.prefs_daysavailable && this.prefs_exercisetype);
        },
        showCert() {
            console.log("Clicked ShowCert...");
            document.getElementById('pers_cert').hidden = !document.getElementById('pers_cert').hidden;
        },
        initPerfArray(){
            this.myFSDetails.map((myd) => { this.perf[myd.life_area] = 0;});
        },
        notNow() {
            this.doubleConfirmSwal("We can't provide you with workout systems, until your preferences and disclaimer acceptance are signified.");
        },
        // savePrefs() {
        //     this.userprefsData? this.userprefsData.agreedterms_cond = this.disclaimer_tick:'';
        //     var agreedtos = this.userprefsData? this.userprefsData.agreedterms_cond:(this.disclaimer_tick? Date.now(): null);
        //     console.log("Saving prefs.TOS: " .agreedtos);

        //     axios.post('/user/prefs/save', {
        //         user_id:this.userinfo.id,
        //         numdaysavailable:this.prefs_daysavailable,
        //         agreedterms_cond: agreedtos,
        //         exercise_type: this.prefs_exercisetype,
        //     })
        //     .then(res => {
        //         this.loading = false;
        //         this.success = true;
        //         this.message = res.data.message;
        //        this.userprefsData =JSON.parse(res.data.userprefs);
        //         console.error(res.data.message);
        //     })
        //     .catch(err => {
        //         // this.loading = false;
        //         // this.failure = true;
        //         console.error(err);
        //     })
        //     .finally(()=> {
        //         //location.reload();
        //         // this.updateToast(this.message, 4000);
        //         this.doubleConfirmOnSavePrefs(this.message) ;
        //         this.message = '';
        //     });
        // },

        // doubleConfirmSwal(message) {
        //     Swal.fire({
        //     title:message,
        //     showDenyButton: true,
        //     showCancelButton: true,
        //     confirmButtonText: 'Skip for now',
        //     denyButtonText: `Let me check it out again`,
        //     }).then((result) => {
        //     /* Read more about isConfirmed, isDenied below */
        //         if (result.isConfirmed) {
        //             Swal.fire('Skipping....', '', 'success');
        //             console.log("Skipping UserPrefs for user: " + this.userinfo.id );
        //         //transfer to SMS home.  TODO
        //         } else if (result.isDenied) {
        //             // Swal.fire('Please review the disclaimer and submit your preferences', '', 'info')

        //         }
        //     });
        // },

        // doubleConfirmOnSavePrefs(message) {
        //     Swal.fire({
        //     title:message,
        //     showDenyButton: false,
        //     showCancelButton: false,
        //     confirmButtonText: 'Thanks, got it.',
        //     denyButtonText: `Let me check it out again`,
        //     }).then((result) => {
        //         if (result.isConfirmed) {
        //             // Swal.fire('Please progress with your Induction workflow', '', 'success');
        //             window.location.reload();
        //         }
        //     });
        // },

        doubleConfirmOnVideoViewed(message) {
            Swal.fire({
            title:"We will hide this video from you as you've watched it",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Thanks, yes, I'm done with it.",
            denyButtonText: `No, please let me view it again!`,
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    Swal.fire("We will hide this video from you as you've watched it.", '', 'success');
                    this.recordQSVideoViewed(true);//true=don't provide a link in future
                    // console.log("Skipping UserPrefs for user: " + this.userinfo.id );
                //    window.location.href='/workout/myworkout';
                } else if ( result.isDenied) {
                     Swal.fire("We will provide you with a menu-link to this video so you can re-watch it.", '', 'success');
                    this.recordQSVideoViewed(false);//false= pls provide a link in future
                }
            });
        },

        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    },
    computed:{
        // getData() {
        //      this.disclaimer_acceptedx = this.disclaimer_accepted;
        // if(this.userprefsData != null){
        //     this.prefs_daysavailable = this.userprefsData.numdaysavailable;
        //     if(this.userprefsData.agreedterms_cond!= null) this.disclaimer_tick = true;
        //     this.prefs_exercisetype = this.userprefsData.exercise_type=='bodywt'? 'bodywttrue':'bodywtfalse';
        // }

        // }
    }
}
</script>


<style scoped>
.video-container {
  position: relative;
}
#appx {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.tooltipx {
  position: absolute;
  /* top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
    top: 10%;
    left: 10%;
    width:80%;
  /* transform: translate(-50%, -50%); */
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  /* display: none; */
}


.arrow-image {
   position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width:60px; /* Adjust the width and height as needed */
    height: 60px;
}
.fai-yellow{
    color:yellow;
}

.heading-border{
    color:#ffffff;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
/*
  @media  (max-width: 768px)  {
    line-height: 2cap;
  } */
}
@media (max-width: 768px) {
  .hide-for-mobile {
    display: none; /* Hide the element on mobile screens */
  }
}
</style>
